import {
  PlayerDrawer,
  Props as PlayerDrawerProps,
} from '@sorare/marketplace/src/components/player/PlayerDrawer';

import PlayerDetails from 'components/player/PlayerDetails';

export type Props = Omit<PlayerDrawerProps, 'PlayerDetails'>;

export const MarketplacePlayerDrawer = ({ cardOpened, onClose }: Props) => {
  return (
    <PlayerDrawer
      cardOpened={cardOpened}
      onClose={onClose}
      PlayerDetails={PlayerDetails}
    />
  );
};
